import { useState } from 'react';
import { User } from 'lucide-react';
import { constructPhotoUrl } from '@/features/ministers/utils/imageProcessing';
import { cn } from '@/lib/utils';

interface MinisterPhotoProps {
  filename: string | null | undefined;
  name?: string | null;
  className?: string;
}

/** Profile photo of a minister, or a neutral placeholder when there is none */
export function MinisterPhoto({ filename, name, className }: MinisterPhotoProps) {
  const [failed, setFailed] = useState(false);
  const url = filename ? constructPhotoUrl(import.meta.env.VITE_SUPABASE_URL, filename) : null;
  if (!url || failed) {
    return (
      <div className={cn('flex shrink-0 items-center justify-center rounded-full bg-muted text-muted-foreground', className ?? 'size-10')}>
        <User className="size-1/2" aria-hidden />
      </div>
    );
  }
  return (
    <img
      src={url}
      alt={name ?? 'Foto'}
      loading="lazy"
      onError={() => setFailed(true)}
      className={cn('shrink-0 rounded-full object-cover', className ?? 'size-10')}
    />
  );
}
